import CheckboxWidget from "./CheckboxWidget";
import DateWidget from "./DateWidget";
import EmailWidget from "./EmailWidget";
import RadioWidget from "./RadioWidget";
import SelectWidget from "./SelectWidget";
import TextareaWidget from "./TextareaWidget";
import TextWidget from "./TextWidget";
import URLWidget from "./URLWidget";
import UpDownWidget from "./UpDownWidget";
import DateTimeWidget from "./DateTimeWidget";

export default {
    TextWidget
    , CheckboxWidget
    , DateWidget
    , DateTimeWidget
    , EmailWidget
    , RadioWidget
    , SelectWidget
    , TextareaWidget
    , UpDownWidget
    , URLWidget
};
